import { Colli, ColliStateName } from '@frontend/colli/types';
import { TransactionStateName } from '@frontend/transaction/types';

export type TransactionStatusDisplay = { type: 'transaction'; state: TransactionStateName } | { type: 'colli'; state: ColliStateName } | { type: 'mixed' };

export function getColliLocationKey(colli: Colli): string {
    return `${colli.current_spot_id ?? ''}|${colli.current_module_id ?? ''}|${colli.current_slot_id ?? ''}`;
}

export function hasMixedColliLocations(collis: Colli[] | null | undefined): boolean {
    if (!collis || collis.length < 2) return false;
    const firstLocationKey = getColliLocationKey(collis[0]);
    return collis.some((colli) => getColliLocationKey(colli) !== firstLocationKey);
}

/** Status from collis when present; otherwise transaction state. Mixed when collis differ in state or location. */
export function getTransactionStatusDisplay(collis: Colli[] | null | undefined, transactionState: TransactionStateName): TransactionStatusDisplay {
    if (!collis || collis.length === 0) {
        return { type: 'transaction', state: transactionState };
    }

    if (collis.length === 1) {
        return { type: 'colli', state: collis[0].state };
    }

    const firstLocationKey = getColliLocationKey(collis[0]);
    const allSameState = collis.every((colli) => colli.state === collis[0].state);
    const allSameLocation = collis.every((colli) => getColliLocationKey(colli) === firstLocationKey);

    if (allSameState && allSameLocation) {
        return { type: 'colli', state: collis[0].state };
    }

    return { type: 'mixed' };
}
